<template>
    <v-row>
      <v-col cols="12">
        <v-card color="transparent" flat>
          <v-card-title>Push Notifications</v-card-title>
          <v-card-text>
            <v-tabs v-model="pushNotificationTab" background-color="transparent">
              <template v-for="(tab, index) in pushNotificationsTabs">
                <v-tab :key="index" class="text-capitalize"> {{tab}} </v-tab>
              </template>
            </v-tabs>
          </v-card-text>
          <v-tabs-items v-model="pushNotificationTab">
            <v-tab-item>
              <NewNotification ref="newNotification" @openSnackbar="openSnackbar"/>
            </v-tab-item>
            <v-tab-item>
              <History />
            </v-tab-item>
            <v-tab-item>
              <Drafts ref="drafts" @select="onSelect"/>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </v-col>
      <v-snackbar v-model="isNotificationSnackbarOpen" :color="notificationSnackbarOptions.color">
        {{ notificationSnackbarOptions.message }}
      </v-snackbar>
      
    </v-row>
</template>

<script>
import utilityMixin from "@/views/csr/mixins/utility";

import NewNotification from './notification/NewNotification'
import History from './notification/History'
import Drafts from './notification/Drafts'


export default {
  components: {
    NewNotification,
    History,
    Drafts
  },

  mixins: [utilityMixin],

  data() {
    return {
      isNotificationSnackbarOpen: false,
      pushNotificationsTabs: ["New", "History", "Drafts"],
      pushNotificationTab: null,
      verticalDotsItems: [
        {
          text: "Starred",
          icon: "mdi-star",
        },
        {
          text: "Done",
          icon: "mdi-check-circle",
        },
      ],
      notificationSnackbarOptions: {
        color: null,
        message: null,
      },
      
    };
  },

  methods: {
    onSelect (params) {
      this.pushNotificationTab = params.tabIndex;
      this.$refs.newNotification.prefillForm(params);
    },
    openSnackbar (params) {
      this.notificationSnackbarOptions = params.content;
      this.isNotificationSnackbarOpen = params.display;
    }
  },
};
</script>
